import { useState, useEffect, useCallback } from "react";

import { DataFeedInstance } from "../../chart-datafeed/udf-compatible-datafeed";
import Subscribed from "../../models/symbolData";

import type { Quotes } from "../../models/symbolData";

const useLiveQuotesGeneric = (
  selectedToken: number,
  selectedMarketSegmentId: number,
  listenerGuid: string
): Subscribed | null => {
  const [liveQuotes, setLiveQuotes] = useState<Subscribed | null>(null);

  // Early return for invalid inputs
  if (selectedToken === undefined || selectedMarketSegmentId === undefined) {
    return null;
  }

  const handleQuotes = useCallback((quotes: Quotes[]) => {
    // Robust input validation
    if (!quotes?.length || !quotes[0]?.v) return;

    const selectedSegment = quotes[0].v;
      setLiveQuotes(selectedSegment);
  }, []);

  useEffect(() => {
    // Guard against uninitialized DataFeed
    if (!DataFeedInstance) {
      console.error('DataFeed is not initialized');
      return;
    }

    // Prevent unnecessary subscriptions
    if (!selectedToken || !selectedMarketSegmentId) return;
    try {
      DataFeedInstance.subcscribeQuotesFromTokens(
        [{ market_segment_id: selectedMarketSegmentId, token: selectedToken }],
        handleQuotes,
        listenerGuid
      );
      return () => {
        if (listenerGuid) {
          DataFeedInstance?.unsubscribeQuotes(listenerGuid);
        }
      };
      
    } catch (error) {
      console.error('Failed to subscribe to quotes:', error);
    }
  }, [selectedToken, selectedMarketSegmentId, handleQuotes]);

  return liveQuotes;
};

export default useLiveQuotesGeneric;